export function formatDate(value) {
    if (!value) return "Unknown time";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
}

// The server sends an empty email when no user row carries the author id, which
// is what a removed account leaves behind. Say that, rather than showing a
// blank where a person belongs.
export function formatAuthor(email) {
    return email || "an account no longer on record";
}
